import { motion } from 'framer-motion';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

const MultipleIncomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="pt-32 pb-16 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-4xl mx-auto px-6">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
            >
              <div className="inline-block mb-6 px-5 py-2 border border-red/20 bg-red/5 rounded-full">
                <span className="text-red text-sm font-medium">確定申告</span>
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 leading-tight">
                複数の収入をもつ
              </h1>
            </motion.div>
          </div>
        </section>

        {/* Article Content */}
        <article className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-6">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="prose prose-lg max-w-none"
            >
              <div className="space-y-8 text-gray-700 leading-relaxed text-[17px]">
                <p>
                  サラリーマンと独立してからの大きな違いは、収入がほぼ1つか複数あるかという違いがある。
                </p>

                <div className="bg-gradient-to-br from-red/5 to-red-light/5 rounded-2xl p-8 border border-red/10 my-10">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">サラリーマンの場合</h2>
                  <p>
                    給料以外収入がないことが多い。
                  </p>
                </div>

                <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6">わたしの場合</h2>
                
                <p>
                  株式投資や不動産投資をしようと勉強等をしたが、
                </p>

                <div className="space-y-6 my-8">
                  <div className="bg-white rounded-xl p-6 border-l-4 border-red shadow-sm">
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="ri-stock-line text-red text-xl"></i>
                      </div>
                      <div>
                        <h3 className="text-lg font-bold text-gray-900 mb-2">株式投資・投資信託</h3>
                        <ul className="space-y-2 text-gray-700">
                          <li className="flex items-start gap-2">
                            <span className="text-red mt-1">•</span>
                            <span>勤務時間中に注文を出すのははばかられた</span>
                          </li>
                          <li className="flex items-start gap-2">
                            <span className="text-red mt-1">•</span>
                            <span>投資信託は手数料が高いので、株価が上がってももうからないことがわかった</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-xl p-6 border-l-4 border-red shadow-sm">
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="ri-building-4-line text-red text-xl"></i>
                      </div>
                      <div>
                        <h3 className="text-lg font-bold text-gray-900 mb-2">不動産投資</h3>
                        <ul className="space-y-2 text-gray-700">
                          <li className="flex items-start gap-2">
                            <span className="text-red mt-1">•</span>
                            <span>物件を見に行く時間が取れなかった</span>
                          </li>
                          <li className="flex items-start gap-2">
                            <span className="text-red mt-1">•</span>
                            <span>銀行と交渉する時間が取れなかったので怖くてできなかった</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200 my-10">
                  <p className="text-center text-lg font-medium text-gray-900">
                    結局、給与収入が頼りになる収入だった。
                  </p>
                </div>

                <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6">独立してからは</h2>

                <p>
                  得意先がゼロでスタートしたので、生活的には大変だった。
                </p>

                <p>
                  しかし得意先が複数できてくると、いきなりゼロになることはないので、得意先が1つのサラリーマンよりは安定してくる。
                </p>

                <div className="bg-gradient-to-br from-red/5 to-red-light/5 rounded-2xl p-8 border border-red/10 my-10">
                  <h3 className="text-xl font-bold text-gray-900 mb-6">独立後の変化</h3>
                  <div className="space-y-4">
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                        <i className="ri-team-line text-red"></i>
                      </div>
                      <div>
                        <strong className="text-gray-900">経営者との直接対話</strong>
                        <p className="text-gray-600 mt-1">経営者と直接話する機会が格段に増えたので、接する情報が全く異なった</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                        <i className="ri-time-line text-red"></i>
                      </div>
                      <div>
                        <strong className="text-gray-900">時間の自由</strong>
                        <p className="text-gray-600 mt-1">サラリーマンより時間の融通が格段にきいたので、海外などに1週間以上の出張も容易になった</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                        <i className="ri-lightbulb-line text-red"></i>
                      </div>
                      <div>
                        <strong className="text-gray-900">ビジネスの種</strong>
                        <p className="text-gray-600 mt-1">人にあっていると、自分でもかんがえられないビジネスの種はあるもので、それの内いくつかがうまくいけば収入になってくる</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-8 border-l-4 border-red shadow-sm my-10">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-money-dollar-circle-line text-red text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-3">結論</h3>
                      <p>
                        そうすると、サラリーマン時代にはうまくいかなかった複数収入というものは、案外簡単に実現するとわかった。
                      </p>
                    </div>
                  </div>
                </div>

                <div className="border-t border-gray-200 pt-8 mt-12">
                  <p className="text-gray-600">
                    独立することで、複数の収入源を持つことが現実的になります。時間の自由と人脈の広がりが、新しいビジネスチャンスを生み出し、より安定した経営基盤を築くことができるのです。
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </article>

        {/* Related Articles */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-gray-900 mb-10 text-center">関連記事</h2>
            <div className="grid md:grid-cols-3 gap-8">
              <a
                href="/blog/company-history-profile"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/blog/company-history-profile');
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }, 100);
                }}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src="https://public.readdy.ai/ai/img_res/078a2e67b8da06ee706de50aa4613620.jpg"
                    alt="会社の沿革"
                    className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="inline-block mb-3 bg-red text-white px-3 py-1 rounded-full text-xs font-medium">
                    会社の沿革
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 group-hover:text-red transition-colors">
                    会社の沿革、経営者のプロフィールは重要
                  </h3>
                </div>
              </a>

              <a
                href="/blog/business-planning"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/blog/business-planning');
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }, 100);
                }}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=business%20planning%20documents%20with%20financial%20charts%20and%20strategic%20roadmap%20on%20clean%20desk%2C%20professional%20workspace%20with%20laptop%20and%20planning%20materials%2C%20organized%20business%20setting%20with%20natural%20lighting%2C%20corporate%20photography%20style%20emphasizing%20strategic%20thinking&width=800&height=500&seq=blog-002&orientation=landscape"
                    alt="事業計画"
                    className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="inline-block mb-3 bg-red text-white px-3 py-1 rounded-full text-xs font-medium">
                    事業計画
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 group-hover:text-red transition-colors">
                    事業計画をつくるのはこんな感じです
                  </h3>
                </div>
              </a>

              <a
                href="/blog/cash-register-management"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/blog/cash-register-management');
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }, 100);
                }}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=modern%20cash%20register%20and%20financial%20management%20system%20in%20retail%20setting%2C%20organized%20point%20of%20sale%20workspace%20with%20clean%20professional%20aesthetic%2C%20business%20technology%20with%20natural%20lighting%2C%20commercial%20photography%20emphasizing%20efficiency%20and%20accuracy&width=800&height=500&seq=blog-004&orientation=landscape"
                    alt="現金管理"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="inline-block mb-3 bg-red text-white px-3 py-1 rounded-full text-xs font-medium">
                    現金管理
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 group-hover:text-red transition-colors">
                    レジ現金管理
                  </h3>
                </div>
              </a>

              <a
                href="/blog/depreciation"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/blog/depreciation');
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }, 100);
                }}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=depreciation%20concept%20with%20business%20assets%20and%20financial%20calculations%2C%20professional%20accounting%20documents%20on%20modern%20desk%2C%20clean%20office%20environment%20with%20natural%20lighting%2C%20business%20photography%20emphasizing%20financial%20planning%20and%20asset%20management&width=800&height=500&seq=blog-005&orientation=landscape"
                    alt="減価償却"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="inline-block mb-3 bg-red text-white px-3 py-1 rounded-full text-xs font-medium">
                    税務
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 group-hover:text-red transition-colors">
                    減価償却
                  </h3>
                </div>
              </a>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-br from-red-dark to-red">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-4xl font-bold text-white mb-6">
                複数収入の実現をサポートします
              </h2>
              <p className="text-white/90 mb-10 text-lg leading-relaxed">
                独立・起業を考えている方、複数の収入源を作りたい方、<br />
                まずは無料相談でお気軽にご相談ください。
              </p>
              <a
                href="/#contact"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/');
                  setTimeout(() => {
                    const element = document.getElementById('contact');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }, 100);
                }}
                className="inline-block bg-white text-red px-12 py-4 rounded-full text-[15px] font-medium hover:bg-gray-50 transition-all hover:scale-105 whitespace-nowrap cursor-pointer shadow-xl"
              >
                無料相談を予約する
              </a>
            </motion.div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default MultipleIncomePage;